import styled from 'styled-components';

export const StyledQuestionAudio = styled.div`
  position: absolute;
  top: -13px;
  right: 13px;
  z-index: 1;

  .ant-btn {
    background: white;
  }
`;
